<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid"
            [title]="'ADD NODE'">

    <form #mapForm="ngForm" autocomplete="off" class="nodes-dialog">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input [(ngModel)]="data.selectedItem.name" matInput name="name" required>
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </form>
</arm-dialog>
